import { useEffect, useState, useContext } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  getDocument,
  getCollection,
  setDocument,
  deleteDocument,
  editDocument,
} from "../Firebase/Redux/Features/Firestore/firestoreSlice";

import useRealtime from "../Firebase/Hooks/useRealtime";
import useStorage from "../Firebase/Hooks/useStorage";

import { globalContext } from "../Context/globalContext";

/**
 *
 * @param consulta { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param collectionName { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param condicionWhere { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param state { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param file { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param files { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param id { Se usa para saber el tipo de consulta que se va a ejecutar }
 * @param urlRedirect { Se usa para saber el tipo de consulta que se va a ejecutar }
 * * @returns
 */
const useDatabase = ({
  consulta,
  collectionName,
  condicionWhere,
  state,
  file,
  files,
  id,
  urlRedirect,
}) => {
  const { collection } = useSelector((state) => state.firestore);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [result, setResult] = useState(false);

  // para las consultas en realtime
  const [consultaRealTime, setConsultaRealTime] = useState({
    consulta: "",
  });
  // retorno de las consultas en realtime
  const [realtime] = useRealtime(consultaRealTime);

  // para las consultas en realtime
  const [consultaStorage, setConsultaStorage] = useState({
    consulta: "",
  });
  // retorno de las consultas en realtime
  const [storage] = useStorage(consultaStorage);
  // retorno del estado redux del storage
  const { url } = useSelector((state) => state.storage);

  const global = useContext(globalContext);
  let loader = global.loader;
  let setLoader = global.setLoader;

  // obtener documento
  const obtenerDocumento = async () => {
    console.log({
      collectionName: collectionName,
      id: id,
    });
    if (loader) setLoader(false);

    let res = await dispatch(
      getDocument({
        collectionName: collectionName,
        id: id,
      })
    );

    setLoader(true);

    setResult(res.payload);
  };

  // obtener colleccion
  const obtenerCollecion = async () => {
    if (!collection[collectionName]) {
      if (loader) setLoader(false);

      let res = await dispatch(
        getCollection({
          collectionName: collectionName,
        })
      );

      setLoader(true);

      setResult(res.payload.data);
    }
  };

  // obtener colleccion en tiempo real
  const obtenerRealTime = async () => {
    if (
      !collection[collectionName] ||
      (collection[collectionName].condicionWhere !==
        condicionWhere.toString() &&
        collection[collectionName].condicionWhere !== "false")
    ) {
      if (loader) setLoader(false);
      setConsultaRealTime({
        consulta: "obtenerRealTime",
        collectionName: collectionName,
        condicionWhere: condicionWhere,
      });
    }
  };

  // funcion de retorno de las consultas en realtime
  const obtenerArray = () => {
    setLoader(true);

    if (!realtime.success) {
      Swal.fire({
        title: "Error",
        text: "La informacion no logro ser obtenida",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "error",
      });

      return setResult([]);
    }

    setResult(realtime);
  };

  // logica para agregar
  const logicaAgregar = () => {
    // evaluamos si esta amndando un archivo y si este archivo aun no se a subido
    if (file && !storage.estado) {
      // priemro: subimos el archivo
      agregarArchivo();
    } else if (files && !storage) {
      // opcion para subir multiples archivos
      // primero: subimos los archivos
      agregarArchivos();
    } else {
      // segundo: agregamos el docuemnto
      agregarDocumento();
    }
  };
  // agregar un archivo
  const agregarArchivo = () => {
    setConsultaStorage({
      consulta: "subirUnArchivo",
      name: state.nombre,
      folder: collectionName,
      file: file,
    });
  };
  // agregar multiples archivos
  const agregarArchivos = () => {
    setConsultaStorage({
      consulta: "subirArchivos",
      name: state.nombre,
      folder: `${collectionName}/${state.nombre}`,
      files,
    });
  };
  // agregar un documento
  const agregarDocumento = async () => {
    if (loader) setLoader(false);

    // evaluamos si se mando un archivo y si se subio correctamente
    if (file && url !== "") state.url = storage.estado;
    if (files && url !== "") state.imagenes = storage;

    let res = await dispatch(
      setDocument({
        collectionName: collectionName,
        state: state,
      })
    );

    setLoader(true);

    if (
      res.payload.status === "failed" ||
      res.meta.requestStatus === "failed"
    ) {
      return Swal.fire({
        title: "Error",
        text: "No se logro enviar la información",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "error",
      }).then(() => {
        history(urlRedirect);
      });
    }

    setTimeout(() => {
      Swal.fire({
        title: "Inserción exitosa",
        text: "Información enviada correctamente",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "success",
      }).then(() => {
        setResult(true);
        history(urlRedirect);
      });
    }, 10);
  };

  // logica para actualizar
  // NOTA: se usa ya que hay dos opciones de actualizar el documento, si cuanta o no con un archivo, continua...
  // NOTA: continuacion...si no tiene archivo pregunta si lo quiere actualizar y despues lo actualiza el documento, continua...
  // NOTA: continuacion...si  tiene archivo pregunta si lo quiere actualizar, despues lo elimina el archivo,  continua...
  // NOTA: continuacion.. sube el nuevo archivo y despues actualiza el docuemnto,
  const logicaActualizar = async () => {
    // evaluamos que el documento a actualizar tenga un archivo
    if (state.url && !storage.estado) {
      // cuenta con archivo y lo vamos a eliminar
      if (await preguntaActualizar()) eliminarArchivo();
    } else if (!state.url) {
      // no cuenta con archivo, solo lo vamos a actualizar
      if (await preguntaActualizar()) actualizarDocumento();
    } else if (storage.tipo === "eliminar" && storage.estado) {
      // cuenta con archivo y ya se elimino, vamos a subir el nuevo archivo
      agregarArchivo();
    } else {
      // cuenta con archivo y ya se elimino, ya se subio el nuevo, vamos a actualizarlo
      actualizarDocumento();
    }
  };
  // preguntamos si desea eliminar el documento
  const preguntaActualizar = async () => {
    setResult(false);
    let res = await new Promise((resolve, reject) => {
      Swal.fire({
        title: "¿Esta seguro de actualizar este campo?",
        text: "No se podra recuperar!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#2DCD22",
        cancelButtonColor: "#d33",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          resolve(true);
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          reject(false);
          Swal.fire({
            title: "Cancelado",
            text: "El campo sigue intacto :)",
            confirmButtonColor: "#2DCD22",
            confirmButtonText: "Continuar",
            icon: "error",
          }).then(() => {
            setResult("false");
          });
        }
      });
    });

    return res;
  };
  // actualizar un documento
  const actualizarDocumento = async () => {
    if (loader) setLoader(false);

    // evaluamos si se mando un archivo y si se subio correctamente
    if (file && url !== "") state.url = storage.estado;

    let res = await dispatch(
      editDocument({
        collectionName: collectionName,
        id: id,
        state: state,
      })
    );

    setLoader(true);

    if (
      res.payload.status === "failed" ||
      res.meta.requestStatus === "failed"
    ) {
      return Swal.fire({
        title: "Error",
        text: "El campo no se pudo actualizar",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "error",
      });
    }

    setTimeout(() => {
      Swal.fire({
        title: "Modificación exitosa",
        text: "El campo fue modificado correctamente",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "success",
      }).then(() => {
        setResult(true);
        history(urlRedirect);
      });
    }, 10);
  };

  // logica para eliminar
  // NOTA: se usa ya que hay dos opciones de eliminar el documento, si cuanta o no con un archivo, continua...
  // NOTA: continuacion...si no tiene archivo pregunta si lo quiere eliminar y despues lo elimina el documento, continua...
  // NOTA: continuacion...si  tiene archivo pregunta si lo quiere eliminar y despues lo elimina el archivo y despues el docuemnto, continua...
  const logicaEliminar = async () => {
    // evaluamos que el documento a eliminar tenga un archivo
    if (state.url && !storage.estado) {
      // cuenta con archivo y lo vamos a eliminar
      if (await preguntaEliminar()) eliminarArchivo();
    } else if (!state.url) {
      // no cuenta con archivo
      if (await preguntaEliminar()) eliminarDocumento();
    } else {
      // cuenta con archivo y ya se elimino
      eliminarDocumento();
    }
  };
  // preguntamos si desea eliminar el documento
  const preguntaEliminar = async () => {
    setResult(false);
    let res = await new Promise((resolve, reject) => {
      Swal.fire({
        title: "¿Esta seguro de eliminar este campo?",
        text: "No se podra recuperar!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#2DCD22",
        cancelButtonColor: "#d33",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          resolve(true);
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          reject(false);
          Swal.fire({
            title: "Cancelado",
            text: "El campo sigue intacto :)",
            confirmButtonColor: "#2DCD22",
            confirmButtonText: "Continuar",
            icon: "error",
          }).then(() => {
            setResult("false");
          });
        }
      });
    });

    return res;
  };
  // eliminar un documento
  const eliminarDocumento = async () => {
    if (loader) setLoader(false);

    let res = await dispatch(
      deleteDocument({
        collectionName: collectionName,
        id: state.id,
      })
    );

    setLoader(true);

    if (
      res.payload.status === "failed" ||
      res.meta.requestStatus === "failed"
    ) {
      return Swal.fire({
        title: "Error",
        text: "El campo no logro ser eliminado",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "error",
      });
    }

    setTimeout(() => {
      Swal.fire({
        title: "Eliminación exitosa",
        text: "El campo fue eliminado correctamente",
        confirmButtonColor: "#2DCD22",
        confirmButtonText: "Continuar",
        icon: "success",
      }).then(() => {
        setResult(true);
        history(urlRedirect);
      });
    }, 10);
  };
  // eliminar archivo
  const eliminarArchivo = async () => {
    setConsultaStorage({
      consulta: "eliminarUnArchivo",
      urlFile: state.url,
    });
  };

  useEffect(() => {
    console.log("useDatabase");
    if (!realtime) {
      switch (consulta) {
        case "obtenerDocumento":
          obtenerDocumento();
          break;
        case "obtenerCollecion":
          obtenerCollecion();
          break;
        case "obtenerRealTime":
          obtenerRealTime();
          break;
        case "agregarDocumento":
          logicaAgregar();
          break;
        case "actualizarDocumento":
          logicaActualizar();
          break;
        case "eliminarDocumento":
          logicaEliminar();
          break;
        case "reset":
          setConsultaStorage({
            consulta: "",
          });
          break;
        case "resetConsult":
          setResult({
            success: "reset",
          });
          break;
        default:
          break;
      }
    } else {
      // consulta en realtime
      setConsultaRealTime({ consulta: "reset" });
      obtenerArray();
    }
    // eslint-disable-next-line
  }, [consulta, realtime, storage]);

  return [result];
};

export default useDatabase;
